import * as React from 'react';

import { Action, Dispatch, bindActionCreators } from 'redux';
import { Pivot, PivotItem } from '@fluentui/react';

import { OnSiteVisits } from './OnSiteVisits';
import { OnSites } from './OnSites';
import { PageHeader } from '../core/PageHeader';
import { Partners } from './Partners';
import { RootState } from '../../redux/types';
import { connect } from 'react-redux';
import { setOnSiteManagerActiveKey } from '../../redux/ui/actions';

export interface OwnProps {}

export interface StateProps {
  onSiteManagerActiveItem: string;
}

export interface DispatchProps {
  actions: {
    setOnSiteManagerActiveKey: (key: string) => void;
  };
}

type OnSiteManagerProps = OwnProps & StateProps & DispatchProps;

export class Component extends React.Component<OnSiteManagerProps> {
  public render(): JSX.Element {
    return (
      <div>
        <PageHeader
          title="On-Site Event Manager"
          pivot={
            <Pivot selectedKey={this.props.onSiteManagerActiveItem || 'appointments'} onLinkClick={this._handleLinkClick}>
              <PivotItem headerText="Appointments" itemKey="appointments" data-tid="btn_appointments" />
              <PivotItem headerText="On-Sites" itemKey="onsites" data-tid="btn_onsites" />
              <PivotItem headerText="Partners" itemKey="partners" data-tid="btn_partners" />
            </Pivot>
          }
        />
        <div style={{ marginTop: 10 }}>
          {(!this.props.onSiteManagerActiveItem || this.props.onSiteManagerActiveItem === 'appointments') && <OnSiteVisits />}
          {this.props.onSiteManagerActiveItem === 'onsites' && <OnSites />}
          {this.props.onSiteManagerActiveItem === 'partners' && <Partners />}
        </div>
      </div>
    );
  }

  private _handleLinkClick = (item?: PivotItem): void => {
    if (item) {
      this.props.actions.setOnSiteManagerActiveKey(item.props.itemKey as string);
    }
  };
}

export function mapStateToProps(state: RootState): StateProps {
  return {
    onSiteManagerActiveItem: state.ui.onSiteManagerActiveItem,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators({ setOnSiteManagerActiveKey }, dispatch),
  };
}

export const OnSiteManager = connect(mapStateToProps, mapDispatchToProps)(Component);
